export default "__VITE_ASSET__BmWOV6DL__"